import React,{useState,createContext} from 'react'


export const QuestionContext = createContext()



export const QuestionContextProvider = ({children}) => {
    const [isTimer,setIsTimer] = useState(false)
    const [questionNumber,setQuestionNumber] = useState(0)
    const questions = [
        {
            question:"Who are the only team to have received a gold version of the PL Trophy",
            options:[
                "Liberty Stadium",
                "Swansea",
                "Leeds United",
                "Arsenal",
            ],
            correct:3
        },
        {
            question:"Which animal is in the flag of Leicester City",
            options:[
                "Sol Campbell",
                "Lion",
                "Fox",
                "Bull",
            ],
            correct:2
        },
        {
            question:"Which current player at West Ham is the longest serving at the club",
            options:[
                "Mark Noble",
                "Man Utd",
                "Fox",
                "Bull",
            ],
            correct:0
        },
        {
            question:"Who is premier league's highest scoring midfielder",
            options:[
                "Dion Dublin",
                "Fox",
                "Sadio Mane",
                "Frank Lampard",
            ],
            correct:3
        },
        {
            question:"Which English club Arjen Robben played for",
            options:[
                "Tottenham Hotspurs",
                "Chelsea",
                "Liverpool",
                "Didlier Drogba",
            ],
            correct:1
        },
    ]

    return (
        <QuestionContext.Provider value={{questions,isTimer,setIsTimer,questionNumber,setQuestionNumber}}>
            {children}
        </QuestionContext.Provider>
    )
}